import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import ListingDetailsMain from './ListingDetailsMain';
import ListingDetailsFooter from './ListingDetailsFooter';

const DetailsPane = () => {
  return (
    <>
      <Row>
        <Col as={Flex} direction="column">
          <ListingDetailsMain />
        </Col>
      </Row>
      <Row>
        <Col as={Flex} direction="column">
          <ListingDetailsFooter />
        </Col>
      </Row>
    </>
  );
};

export default DetailsPane;
